var _defs, _rect, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:rgba(66,133,244,0.3);}.b,.e{fill:#4285f4;}.c,.i{fill:none;}.d{fill:#fff;}.e,.f,.g,.h,.i{fill-rule:evenodd;}.f{fill:#34a853;}.g{fill:#fbbc05;}.h{fill:#ea4335;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 46,
    height: 46
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 40,
    height: 40,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 40,
    height: 40,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 40,
    height: 40,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 40,
    height: 40,
    rx: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 38,
    height: 38,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 38,
    height: 38,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 38,
    height: 38,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 38,
    height: 38,
    rx: 1
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(14 14)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M17.64,9.2a10.341,10.341,0,0,0-.164-1.841H9v3.481h4.844a4.14,4.14,0,0,1-1.8,2.716V15.82h2.909A8.777,8.777,0,0,0,17.64,9.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M9,18a8.592,8.592,0,0,0,5.956-2.18l-2.909-2.258A5.43,5.43,0,0,1,3.964,10.71H.957v2.332A9,9,0,0,0,9,18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M3.964,10.71a5.321,5.321,0,0,1,0-3.42V4.958H.957a9.011,9.011,0,0,0,0,8.084L3.964,10.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M9,3.58a4.862,4.862,0,0,1,3.44,1.346l2.581-2.581A8.649,8.649,0,0,0,9,0,9,9,0,0,0,.957,4.958L3.964,7.29A5.364,5.364,0,0,1,9,3.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M0,0H18V18H0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleButton);
export default __webpack_public_path__ + "static/media/Google-Button.e2bdea28a7654357afa8f5e8755ceb5a.svg";
export { ForwardRef as ReactComponent };